export default __webpack_public_path__ + "static/media/o5.51346ba9.jpg";